// @ts-expect-error moduleResolution:nodenext issue 54523
import { html } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property } from 'lit/decorators.js';
import LightElement from './light-element.js';
import SiteFonts from '../../typescript/modules/site-fonts.js';
import Logger from '../../typescript/modules/logger.js';

declare global {
	interface Window {
		paypal?: any;
	}
}

@customElement('paypal-message')
export default class PayPalMessage extends LightElement {

	@property({ type: Number })
	amount: number;

	@property({ type: String })
	pageType: string = 'product-details';

	@property({ type: String })
	logoType: string = 'inline';

	@property({ type: String })
	layout: string = 'text';

	private scriptLoaded = false;

	private paypalConfig: {
		payPalApiClientID: string;
		payPalFontUrl: string;
	} = {
			payPalApiClientID: '',
			payPalFontUrl: ''
		};

	async connectedCallback() {
		super.connectedCallback();
		this.loadPayPalConfig();
		await this.loadPayPalScript();
	}

	private loadPayPalConfig() {
		const configElement = document.querySelector('.js-paypal-config') as HTMLScriptElement;
		if (configElement) {
			try {
				this.paypalConfig = JSON.parse(configElement.textContent || '{}');
			}
			catch (error) {
				Logger.trackException(new Error('PayPal Message: Failed to JSON parse PayPal configuration.'));
			}
		}
	}

	private async loadPayPalScript() {

		if (window.paypal || this.scriptLoaded) {
			return;
		}

		const existingScript = document.querySelector('script[src*="paypal.com/sdk/js"]');
		if (existingScript) {
			this.scriptLoaded = true;
			return;
		}

		if (!this.paypalConfig.payPalApiClientID) {
			Logger.trackException(new Error('PayPal Message: Missing PayPal API Client ID in configuration.'));
			return;
		}

		const script = document.createElement('script');
		script.src = `https://www.paypal.com/sdk/js?client-id=${this.paypalConfig.payPalApiClientID}&currency=GBP&components=messages`;
		script.async = true;
		document.head.appendChild(script);

		await new Promise<void>((resolve, reject) => {
			script.onload = () => {
				this.scriptLoaded = true;
				resolve();
			};
			script.onerror = () => {
				Logger.trackException(new Error('PayPal Message: Failed to load PayPal SDK script'));
				reject(new Error('PayPal Message: Failed to load PayPal SDK script'));
			};
		});
	}

	private getFontFamily(): string {
		const font = SiteFonts.getFont();
		return font ? `['${font.family}', 'system-ui', 'sans-serif']` : "['system-ui', 'sans-serif']";
	}

	private getFontSource(): string {
		const font = SiteFonts.getFont();
		const fileName = font ? font.fileName : 'fonts/brandontext/BrandonTextWeb-Regular/font.woff2';
		return `${this.paypalConfig.payPalFontUrl}/${fileName}`;
	}

	render() {

		return html`
			<div
			data-pp-message
			data-pp-amount="${this.amount}"
			data-pp-countryCode="GB"
			data-pp-placement="${this.pageType}"
			data-pp-style-layout="${this.layout}"
			data-pp-style-text-color="black"
			data-pp-style-text-size="15"
			data-pp-style-text-align="left"
			data-pp-style-logo-type="${this.logoType}"
			data-pp-style-logo-position="right"
			data-pp-style-text-fontfamily="${this.getFontFamily()}"
			data-pp-style-text-fontsource="${this.getFontSource()}"
			data-pp-style-ratio="8x1"
			data-pp-stageTag=""></div>
		`;

	}

}
